import { Description } from '@headlessui/react';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { Visible } from '../../components/common/LayoutComponents';

const testIds = {
  modalItem: 'ErrorModalItem::modalItem',
  title: 'ErrorModalItem::title',
  textContent: 'ErrorModalItem::textContent',
  additionalDetails: 'ErrorModalItem::additionalDetails',
};

type ErrorModalItemProps = {
  readonly title?: string;
  readonly details: string;
  readonly additionalDetails?: string;
  readonly className?: string;
};

export const ErrorModalItem: FC<ErrorModalItemProps> = ({
  title,
  details,
  additionalDetails,
  className,
}) => {
  return (
    <div
      className={twMerge('rounded-xs px-4 py-3', className)}
      data-testid={testIds.modalItem}
    >
      <Visible visible={!!title}>
        <h5 className="inline" data-testid={testIds.title}>
          {title}
        </h5>
      </Visible>
      <div className="pl-3">
        <Description data-testid={testIds.textContent}>{details}</Description>
        <Visible visible={!!additionalDetails}>
          <p
            className="inline font-mono text-sm text-gray-500"
            data-testid={testIds.additionalDetails}
          >
            {additionalDetails}
          </p>
        </Visible>
      </div>
    </div>
  );
};
